export interface VertragsvorlageSpeicherfehler {
  ziel: 'name' | 'beschreibung' | 'oben';
  text: string;
}

export const VERTRAG_ZU_GROSS_TEXT =
  'Der Vertrag ist zu groß zum Speichern. Bitte kürzen oder auf mehrere Vorlagen aufteilen.';
export const VERTRAG_INHALT_FEHLT_TEXT = 'Bitte einen Inhalt eingeben';

const FEHLER: Record<string, VertragsvorlageSpeicherfehler> = {
  ASSIGNMENT_REQUIRED: { ziel: 'oben', text: 'Bitte Art, Firma, Vertragsart und Für vollständig auswählen.' },
  INVALID_ASSIGNMENT: { ziel: 'oben', text: 'Bitte die Zuordnung nach Art, Firma, Vertragsart und Für prüfen.' },
  INVALID_ASSIGNMENT_BRANCH_OFFICE: {
    ziel: 'oben',
    text: 'Die ausgewählte Firma ist nicht mehr verfügbar. Bitte die Firmen erneut laden und eine Firma auswählen.',
  },
  INVALID_ASSIGNMENT_CONTRACT_TYPE: {
    ziel: 'oben',
    text: 'Die ausgewählte Vertragsart ist nicht mehr verfügbar. Bitte die Vertragsarten erneut laden und eine Vertragsart auswählen.',
  },
  INVALID_ASSIGNMENT_COMBINATION: { ziel: 'oben', text: 'Pro Holidays ist nur für Mein Urlaubsglück möglich.' },
  DUPLICATE_NAME: { ziel: 'name', text: 'Eine Vertragsvorlage mit diesem Namen existiert bereits' },
  INVALID_NAME: { ziel: 'name', text: 'Bitte einen Namen mit höchstens 120 Zeichen eingeben' },
  INVALID_DESCRIPTION: {
    ziel: 'beschreibung',
    text: 'Die interne Beschreibung darf höchstens 250 Zeichen lang sein',
  },
  INVALID_CONTENT: { ziel: 'oben', text: VERTRAG_INHALT_FEHLT_TEXT },
  INVALID_DOCUMENT: {
    ziel: 'oben',
    text: 'Der Vertrag konnte nicht gespeichert werden, weil sein Aufbau ungültig ist.',
  },
  UNSUPPORTED_DOCUMENT_VERSION: {
    ziel: 'oben',
    text: 'Diese Vertragsvorlage wurde mit einer anderen Version des Editors erstellt und kann nicht gespeichert werden.',
  },
  DOCUMENT_TOO_LARGE: { ziel: 'oben', text: VERTRAG_ZU_GROSS_TEXT },
  DOCUMENT_REQUIRED: {
    ziel: 'oben',
    text: 'Diese Vertragsvorlage wurde im neuen Editor erstellt und kann nur dort geändert werden.',
  },
  NOT_FOUND: {
    ziel: 'oben',
    text: 'Diese Vertragsvorlage wurde inzwischen gelöscht und kann nicht mehr gespeichert werden.',
  },
};

const ALLGEMEINER_FEHLER: VertragsvorlageSpeicherfehler = {
  ziel: 'oben',
  text: 'Die Vorlage konnte nicht gespeichert werden. Bitte versuche es erneut.',
};

function alsObjekt(wert: unknown): Record<string, unknown> | undefined {
  return typeof wert === 'object' && wert !== null ? (wert as Record<string, unknown>) : undefined;
}

/** RITA-1541: Zusatzangaben des ersten GraphQL-Fehlers (z. B. `code`, `updated_at`, `display_name`). */
export function graphqlFehlerErweiterungen(fehler: unknown): Record<string, unknown> {
  const graphQLFehler = alsObjekt(fehler)?.graphQLErrors;
  const ersterFehler = Array.isArray(graphQLFehler) ? alsObjekt(graphQLFehler[0]) : undefined;
  return alsObjekt(ersterFehler?.extensions) ?? {};
}

/** Fehlercode des ersten GraphQL-Fehlers oder undefined. */
export function graphqlFehlerCode(fehler: unknown): string | undefined {
  const { code } = graphqlFehlerErweiterungen(fehler);
  return typeof code === 'string' ? code : undefined;
}

/** Technische Servertexte bleiben verborgen; die Stelle und Meldung richten sich nach dem Fehlercode. */
export function speicherfehlerZuordnen(fehler: unknown): VertragsvorlageSpeicherfehler {
  const antwort = alsObjekt(fehler);
  const netzfehler = alsObjekt(antwort?.networkError);
  if (netzfehler?.statusCode === 413 || alsObjekt(netzfehler?.response)?.status === 413) {
    return { ziel: 'oben', text: VERTRAG_ZU_GROSS_TEXT };
  }
  const code = graphqlFehlerCode(fehler);
  if (code === 'ASSIGNMENT_CONFLICT') {
    const { template_name: name } = graphqlFehlerErweiterungen(fehler);
    const andere = typeof name === 'string' && name ? `„${name}“` : 'eine andere Vorlage';
    return {
      ziel: 'oben',
      // RITA-1572: Ohne „alle Vertragsarten“ gibt es nur noch gleiche Zuordnungen, keine Überschneidungen.
      text: `Nicht gespeichert. Die Zuordnung ist bereits durch ${andere} vergeben. Bitte ändere die Zuordnung. Deine Eingaben bleiben erhalten.`,
    };
  }
  return code !== undefined && Object.prototype.hasOwnProperty.call(FEHLER, code)
    ? { ...FEHLER[code] }
    : { ...ALLGEMEINER_FEHLER };
}
